import { useCallback } from 'react';

interface IYourDataModalProps {
    ccpaType: string;
}

export default function YourDataModal(props: IYourDataModalProps) {
    const { ccpaType } = props;
    const onClick = useCallback(
        // @ts-expect-error - target.innerText does exist, but types are not properly inferred
        (e) => {
            const isBehalf = e.target.innerText.toLowerCase() === 'myself' ? '' : '/behalf';
            const url = `/my-data/${ccpaType}${isBehalf}`;
            location.href = url;
        },
        [ccpaType],
    );

    return (
        <div className="your-data-dialog" aria-label="Your Data Request">
            <p className="p-b-s">
                Are you submitting this request for yourself or for a different person for whom you have authorization
                to do so?
            </p>
            <hr />
            <div className="your-data-dialog__buttons">
                <button className="hm-btn--tertiary" onClick={onClick}>
                    Someone&nbsp;Else
                </button>
                <button className="hm-btn--tertiary" onClick={onClick}>
                    Myself
                </button>
            </div>
        </div>
    );
}
